import { styled } from "@mui/system";
import { Box } from "@mui/material";

export const ChatBubbleStyles = styled(Box)(({ theme, isBot,popupWidth, isFullScreen }) => ({
  "&.bubble": {
    height: 'fit-content',
    maxHeight: 'fit-content',
    maxWidth: '90%',
    width: 'fit-content',
    padding: theme.spacing(0.5), // Equivalent to 4px
    marginBottom: theme.spacing(1), // Equivalent to 8px
    display: 'flex',
    flexDirection: 'column',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    backgroundColor: isBot ? theme.palette.datagrid.main : theme.palette.primary.main, // Replaced #e5e6ec and #2f2f2f
    alignSelf: isBot ? 'flex-start' : 'flex-end',
    marginLeft: isBot ? theme.spacing(4) : '0px', // Equivalent to 32px
    marginTop: theme.spacing(0.5), // Equivalent to 4px
    color: isBot ? theme.palette.primary.dark : theme.palette.common.white, // Replaced #2f2f2f and #fff
    marginRight: isBot ? '0px' : theme.spacing(0.625), // Equivalent to 5px
    borderRadius: isBot ? '0 24px 24px 24px' : '16px 0 16px 16px', // Border radius remains as is
  },
  "& .bubbleText": {
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    marginBottom: theme.spacing(0.5), // Equivalent to 4px
    paddingRight: theme.spacing(1), // Equivalent to 8px
    paddingLeft: theme.spacing(1), // Equivalent to 8px
    paddingTop:0,
    paddingBottom:0,
    fontSize: isFullScreen
        ? `${theme.typography.pxToRem(20)} !important`
        : `${theme.typography.pxToRem(17)} !important`,
    lineHeight: isFullScreen ? '1.6 !important' : '1.4 !important',

    "& .markdown-body": {
      fontSize: isFullScreen
          ? `${theme.typography.pxToRem(20)} !important`
          : `${theme.typography.pxToRem(17)} !important`,
      lineHeight: isFullScreen ? '1.6 !important' : '1.4 !important',


      "& table": {
        fontSize: isBot
            ? (isFullScreen
                ? `${theme.typography.pxToRem(18)} !important`
                : `${theme.typography.pxToRem(14)} !important`)
            : 'inherit !important',

        // Table container styling for full width and scrolling
        display: 'block !important',
        width: '100% !important',
        maxWidth: '100% !important',
        overflowX: 'auto !important',
        overflowY: 'hidden !important',
        whiteSpace: 'nowrap !important',
        borderCollapse: 'separate !important',
        borderSpacing: 0,
        position: 'relative !important',

        // Add scroll indicator gradient (only show when not scrolled)
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          width: '20px',
          background: `linear-gradient(to left, ${isBot ? theme.palette.datagrid.main : theme.palette.primary.dark}, transparent)`,
          pointerEvents: 'none',
          opacity: 0.8,
          transition: 'opacity 0.3s ease',
        },

        // Add scroll hint text (only show when not scrolled)
        '&::before': {
          content: '"→"',
          position: 'absolute',
          top: '50%',
          right: '5px',
          transform: 'translateY(-50%)',
          fontSize: '12px',
          color: theme.palette.text.secondary,
          opacity: 0.6,
          pointerEvents: 'none',
          zIndex: 1,
          transition: 'opacity 0.3s ease',
        },

        // Hide scroll indicators when scrolled
        '&:not([data-scrolled="false"])::after': {
          opacity: 0,
        },

        '&:not([data-scrolled="false"])::before': {
          opacity: 0,
        },

        "& th, & td": {
          fontSize: 'inherit !important',
          lineHeight: '1.2 !important',
          padding: theme.spacing(1),
          whiteSpace: 'nowrap !important',
          minWidth: 'max-content !important',
        },

        "& tr": {
          display: 'table-row !important',
          width: 'max-content !important',
        },
      },
      // Override specific markdown elements with proportional scaling
      "& p": {
        fontSize: 'inherit !important',
        lineHeight: 'inherit !important',
        margin: 0,
      },
      "& h1": {
        fontSize: isFullScreen
            ? `${theme.typography.pxToRem(35)} !important`  // 2em scaled: 23*1.6≈36
            : `${theme.typography.pxToRem(28)} !important`, // 2em scaled: 18*1.6≈29
      },
      "& h2": {
        fontSize: isFullScreen
            ? `${theme.typography.pxToRem(26)} !important`  // 1.5em scaled: 23*1.2≈27
            : `${theme.typography.pxToRem(21)} !important`, // 1.5em scaled: 18*1.2≈22
      },
      "& h3": {
        fontSize: isFullScreen
            ? `${theme.typography.pxToRem(22)} !important`  // 1.25em scaled: 23*1≈23
            : `${theme.typography.pxToRem(17)} !important`, // 1.25em scaled: 18*1≈18
      },
      "& h4": {
        fontSize: isFullScreen
            ? `${theme.typography.pxToRem(19)} !important`  // 1em scaled: 23*0.9≈20
            : `${theme.typography.pxToRem(15)} !important`, // 1em scaled: 18*0.9≈16
      },
      "& h5": {
        fontSize: isFullScreen
            ? `${theme.typography.pxToRem(17)} !important`  // 0.875em scaled
            : `${theme.typography.pxToRem(13)} !important`,
      },
      "& h6": {
        fontSize: isFullScreen
            ? `${theme.typography.pxToRem(15)} !important`  // 0.85em scaled
            : `${theme.typography.pxToRem(12)} !important`,
      },
      "& li": {
        fontSize: 'inherit !important',
        lineHeight: 'inherit !important',
      },
      "& blockquote": {
        fontSize: 'inherit !important',
        lineHeight: 'inherit !important',
      },
    },

    "& code": {
      overflowX: 'auto',
      maxWidth: '100%',
      display: 'block',
      backgroundColor: theme.palette.datagrid.odd,
      padding: theme.spacing(1),
      borderRadius: theme.shape.borderRadius,
      margin:0,
      fontSize: isFullScreen
          ? `${theme.typography.pxToRem(20)} !important`
          : `${theme.typography.pxToRem(16)} !important`,
    },

  },
  "& .loadingText": {
    marginRight: theme.spacing(0.5),
    fontSize: isFullScreen
        ? `${theme.typography.pxToRem(16)} !important`
        : `${theme.typography.pxToRem(13)} !important`,
    color: "grey",
    fontStyle: "italic",

  },
"& .loadingMessage": {
  paddingTop: theme.spacing(0.5),
  display: 'flex',
  flexDirection: 'row', // Align items horizontally
  alignItems: 'center', // Center items vertically
  gap: theme.spacing(0), // Add space between text and spinner
  animation: "float 1.6s ease-in-out infinite",
  "@keyframes float": {
    "0%": { transform: "translateY(0px)" },
    "50%": { transform: "translateY(-4px)" },
    "100%": { transform: "translateY(0px)" },
  },
},
  '& .chatBubbleTable': {
    maxWidth: '100%', // Full width of the bubble
    width: '5000px', // Full width of the bubble
    height: '70%',
    overflowX: 'auto', // Allow scrolling if content overflows
    overflowY: 'hidden', // Allow scrolling if content
    flexGrow: 1, // Allows the table to grow within the chat bubble
  },
  "& .LoadingComponent":{
    paddingTop: theme.spacing(0.4),
    color: `${theme.palette.grey.medium}!important`,
  },

}));

export default ChatBubbleStyles;
